export async function MountLandingPage(props: any, el: Element) {
	const a = await import('./LandingPage');
	a.MountLandingPage(props, el);
}

(window as any).MountLandingPage = MountLandingPage;
